import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Container>
        <Row className="justify-content-center text-center">
          <Col md={6}>
            <h1 className="fw-bold text-primary" style={{ fontSize: "8rem" }}>
              404
            </h1>

            <h3 className="fw-bold mt-3">Page Not Found</h3>

            <p className="text-muted fs-5 mt-3">
              Sorry, the page you’re looking for doesn’t exist or has been
              moved.
            </p>

            <div className="mt-4 d-flex justify-content-center gap-3">
              <Button
                size="md"
                className="rounded-pill px-4"
                onClick={() => navigate("/")}
              >
                Go Home
              </Button>

              <Button
                size="md"
                variant="outline-secondary"
                className="rounded-pill px-4"
                onClick={() => navigate(-1)}
              >
                Go Back
              </Button>
            </div>

            <div className="mt-5 text-muted small">
              If you believe this is a mistake, feel free to contact me.
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default NotFoundPage;
